<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  [floorplanItem]="kvm()"
  [imageUrl]="imageUrl"
  [fallbackImageUrl]="fallbackImageUrl"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
>
  <div data-main>
    <app-floorplan-item-attachments-button
      [productItems]="productItems"
      [monitoringCategory]="MonitoringCategory.KVMS"
      [monitoringItems]="monitoringItems"
      [monitoringTitle]="monitoringTitle"
    ></app-floorplan-item-attachments-button>
    <app-floorplan-item-group [floorplanItem]="kvm()"></app-floorplan-item-group>
  </div>
  @if (extent() !== SidesheetExtent.None) {
    <div data-extended>
      <app-floorplan-custom-part-numbers [floorplanItem]="kvm()"></app-floorplan-custom-part-numbers>
    </div>
  }
</app-floorplan-item-details>
